export default __webpack_public_path__ + "static/media/IMG_2026.d01e0545.JPG";